Vue.component("login", {
    props: ["config"],
    template: `
        <div class="login__wrapper">
            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                <div id="login" v-if="showLogin">
                    <aside class="login__info__wrapper">
                        <h3>Login</h3>
                        <!-- <h4 v-html="config.loginTitle"></h4> -->

                        <div class="login__info__inputs__wrapper">
                            <div :class="thisFieldEmptyError(name)">
                                <input type="text" v-model="name" placeholder="Navn" @keyup="inputKeyup">
                            </div>
                            <div :class="[thisFieldEmptyError(email), hasEmailError(email)]">
                                <input type="text" v-model="email" placeholder="Email" @keyup="inputKeyup">
                            </div>
                            <div :class="[thisFieldEmptyError(pass), hasPasswordError(pass)]">
                                <input type="text" v-model="pass" placeholder="Password" @keyup="inputKeyupPassword">
                            </div>
                        </div>
                        
                        <button @click="loginHandler">LOGIN</button>
                    </aside>
                </div>
            </transition>


            <aside id="login__title__wrapper">
                <h3>VELKOMMEN /</h3>
                <h1 v-html="config.loginTitle"></h1>
                <h2 v-html="config.timestamp"></h2>
                <h5 v-html="config.loginSubtitle" v-if="config.loginSubtitle !== ''"></h5>
                <transition enter-active-class="fadeInIntro" leave-active-class="fadeOut animated">
                    <button v-if="!showLogin" @click="goto">DELTAG</button>
                </transition>
            </aside>

            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                <img class="login__background" v-if="!showLogin" :src="config.replacementBackground.src">
            </transition>
        </div>
    `,
    data() {
        return {
            showLogin: true,

            name: '',
            email: '',
            pass: '',
            password: '',
            sceneRoute: '',
            showInputErrors: false,
            isValidPassword: false
        }
    },
    mounted() {
        this.getPassword();
        this.skipLogin();
    },
    methods: {
        skipLogin() {
            if (this.config.enabled === false) {
                app.authentication.login({name: "guest", email: "place@holder.dk"}, "password");
                this.showLogin = false;
            }
        },
        inputKeyup(event) {
            if(event.key == "Enter") {
                this.loginHandler();
            }
        },
        inputKeyupPassword(event) {
            if(event.key == "Enter") {
                this.loginHandler();
            } else {
                this.isValidPassword = false;
            }
        },
            

        validEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email) && this.showInputErrors;
        },
        thisFieldEmptyError(field) {
            return {
                'input--error': field === '' && this.showInputErrors
            }
        },
        hasEmailError(email) {
            return {
                'input--emailerror': !this.validEmail(email) && this.showInputErrors
            }
        },
        validPassword() {
            return this.isValidPassword
        },
        validatePassword (password, keymatch) {
            console.log(password, keymatch)
            var md = forge.md.sha256.create();
            md.update(password.toLowerCase());
            
            return md.digest().toHex() === keymatch;
        },
        hasPasswordError() {
            return {
                'input--passerror': !this.validPassword() && this.showInputErrors
            }
        },

        logEntry() {
            var loginEndpoint = "https://klgateway.azurewebsites.net/api/v1/eventlogger/events";
            let eventName = app.settings.get("eventName").value

            var formData = {
                "type": "login",
                "event": eventName,
                "name": this.name,
                "email":  this.email
            }
            

            fetch(loginEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type' : 'application/json'
                },
                body: JSON.stringify(formData)
            })
        },

        loginHandler() {
            this.isValidPassword = this.validatePassword(this.pass, this.password);

            if(this.inputErrors.length === 0) {
                this.logEntry();
                this.login();
            } else {
                this.showInputErrors = true;
            }
        },


        login() {
            this.showInputErrors = false;
            let user = {
                name: this.name,
                email: this.email
            }

            app.authentication.login(user, this.pass);

            this.showLogin = false;
        },

        goto() {
            if(this.config.sceneRoute !== '') {
                console.log('GOTOSCENE', this.config.sceneRoute);

                var route = false;
                var sceneInfo = touchKit.PageManager.sceneInfo(this.config.sceneRoute);

                if (sceneInfo.route) {
                    route = '/' + sceneInfo.route;
                }

                if (route && this.$route.path !== route) {
                    this.$router.push(route);
                }
            } else if (this.config.route !== '') {
                this.$router.push(this.config.route)
            }
        },
        getPassword() {
            this.password = this.config.password;
        }
    },
    computed: {
        isLoggedIn() {
            return app.authentication.user() === null ? false : app.authentication.user().loggedIn
        },

        inputErrors() {
            let errors = [];

            // are required fields filled?
            this.inputsFilled ? '' : errors.push("Udfyld felter");

            //is this valid email?
            this.validEmail(this.email) ? '' : errors.push("Ugyldig email");

            //is this valid password?
            this.validPassword() ? '' : errors.push("Forkert password");


            return errors;
        },
        inputsFilled() {
            return (this.name !== '' && this.email !== '' && this.pass !== '')
        }
    },
});